/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import { useState, useContext } from 'react';
import { Route as CustomRoute } from '../../../router/Route';
import ComingSoonPage from '../../Shared/ComingSoonPage';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import LocalSourcingWizard from './LocalSourcingWizard';
import { LocalSourcing } from '../LocalSourcing';
import AgreementDetails from '../../CustomerOrder/AgreementDetails/CustomerOrderAgrDetails';
import POStatus from '../../CustomerOrder/PO Status/POStatus';
import Deliverymethod from '../../CustomerOrder/DeliveryMethod/DeliveryMethod';
import { useLocalSourcingCustomer } from './useLocalSourcingCustomer';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {
  /* intentional noop */
};

export default function LocalSourcingRoute() {
  const [localSourcingCompleted, setLocalSourcingCompleted] = useState(false);
  const [agrDetailsCompleted, setAgrDetailsCompleted] = useState(false);
  const [preliminaryPaymentCompleted, setPreliminaryPaymentCompleted] =
    useState(false);
  const [poStatusCompleted, setPOStatusCompleted] = useState(false);
  const [initialPaymentCompleted, setInitialPaymentCompleted] = useState(false);
  const [deliveryMethodCompleted, setDeliveryMethodCompleted] = useState(false);

  const { featureFlagDetails } = useContext(FeatureFlagContext);

  // Fetches customer data once, stores in AgreementContext for all steps
  const customerId = useLocalSourcingCustomer();

  // Wait until the feature flag has been fetched (undefined means still loading)
  if (featureFlagDetails?.EnableLocalSourcing === undefined) {
    return null;
  }

  return featureFlagDetails?.EnableLocalSourcing == '1' ? (
    <>
      <div>
        <div className="tab-content container-pb-custom">
          <div className="">
            <div className="">
              <div
                id="smartwizard"
                className="p-0 sw sw-theme-default sw-justified"
              >
                <LocalSourcingWizard
                  customerId={customerId}
                  LocalSourcingCompleted={localSourcingCompleted}
                  AgreementDetailsCompleted={agrDetailsCompleted}
                  PreliminaryPaymentCompleted={preliminaryPaymentCompleted}
                  POStatusCompleted={poStatusCompleted}
                  InitialPaymentCompleted={initialPaymentCompleted}
                  DeliveryMethodCompleted={deliveryMethodCompleted}
                />

                <CustomRoute path="/agreement/localsourcing">
                  <LocalSourcing />
                </CustomRoute>
                <CustomRoute path="/agreement/customerorder/details">
                  <AgreementDetails
                    CoCustomerDetails={{ coCustomerId: '' }}
                    setItemSearchCompleted={setLocalSourcingCompleted}
                  />
                </CustomRoute>
                <CustomRoute path="/agreement/customerorder/postatus">
                  <POStatus
                    setItemSearchCompleted={setLocalSourcingCompleted}
                    setAgrDetailsCompleted={setAgrDetailsCompleted}
                    setPreliminaryPaymentCompleted={
                      setPreliminaryPaymentCompleted
                    }
                    func={noop}
                  />
                </CustomRoute>
                <CustomRoute path="/agreement/customerorder/delivery">
                  <Deliverymethod
                    setItemSearchCompleted={setLocalSourcingCompleted}
                    setAgrDetailsCompleted={setAgrDetailsCompleted}
                    setPreliminaryPaymentCompleted={
                      setPreliminaryPaymentCompleted
                    }
                    setPOStatusCompleted={setPOStatusCompleted}
                    setInitialPaymentCompleted={setInitialPaymentCompleted}
                    setWizardAgrId={noop}
                    func={noop}
                  />
                </CustomRoute>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <ComingSoonPage />
  );
}
